import {
  VerifyQrCodePayload,
  VerifyQrCodeResponse,
} from '../../../../types/requests';
import { ConstructPost } from '../../../types/ConstructPost';
import { TWO_FACTOR_BASE_PATH } from '../constants/twoFactorBasePath';

export const postConfirmQrCode = (
  constructPost: ConstructPost,
  data: VerifyQrCodePayload,
): Promise<VerifyQrCodeResponse | undefined> =>
  constructPost<VerifyQrCodeResponse>(
    `${TWO_FACTOR_BASE_PATH}/confirm`,
    { data },
    { preventDefaultErrorToast: true },
  );
